import { render, staticRenderFns } from "./Bingo.vue?vue&type=template&id=022fea13&scoped=true&"
import script from "./Bingo.vue?vue&type=script&lang=ts&"
export * from "./Bingo.vue?vue&type=script&lang=ts&"
import style0 from "./Bingo.vue?vue&type=style&index=0&id=022fea13&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022fea13",
  null
  
)

export default component.exports